import PropTypes from 'prop-types'
import Link from 'next/link'
import classNames from 'classnames'

import Icon from '../../icon'

import { useWebinarSusbcription } from './hooks'

import ArrowRight from '../../icon/arrow-right.svg'

const Action = ({ webinar, ...attrs }) => {
  const { handleSubscription } = useWebinarSusbcription(webinar)

  return <Link
    href={`/webinars/${webinar.id}/${webinar.meta.slug}`}>
    <a
      className={
        classNames([
          'self-end',
          'block',
          'w-full',
          'flex',
          'flex-row',
          'justify-center',
          'text-center',
          'bg-green-500',
          'text-white',
          'py-3',
          'px-6',
          'hover:bg-green-400',
          'active:bg-green-600'
        ])
      }
      style={{
        borderRadius: '0 1.5rem 1.5rem 1.5rem'
      }}
      onClick={handleSubscription}>
      Únete ahora
      <Icon
        className={'ml-2'}
        svg={ArrowRight}
        width={24}
        height={24} />
    </a>
  </Link>
}

Action.propTypes = {
  webinar: PropTypes.object
}

export default Action
